const ContentHeader = ({ children }) => {
  return (
    <section style={{ padding: "28px 28px 16px" }}>
      {children}
    </section>
  );
};

export default ContentHeader;
